import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
// import { LayoutOne } from '../components/layout_one'
import * as ReactSpring from 'react-spring';
// import { theme } from '../theme'
// import { BottomLine } from '../components/bottom_line'
// import { centerHorizontal, centerVertical } from '../media'
// import Lottie from 'lottie-react-web'
// import ErrorCheckboxAnimation from '../resources/animations/error_checkbox_animation.json'
// import { media } from '../media'
// import { SPRING_ANIMATION_CONFIG } from '../constants'
// import { DataContext } from '../context/data_context'
// import { LanguageContext } from '../context/language_context'
// import { useLocation } from 'react-router-dom'
// import { SOME_ERROR_SCREEN_MESSAGES } from '../resources/translations/errors_screen_messages'
// import { BottomButton, BUTTON_HEIGHT } from '../components/bottom_button'
// import { ROUTES } from '../context/enums'
// import { useHistory } from 'react-router-dom'
import { isMobile, isTablet } from 'react-device-detect';
// import { LayoutContainer, LayoutTwoContent, InnerContainer } from './common_styled'
// import { HeaderOne, HEIGHT_MOBILE } from './header_one'
// import { TargetContext } from '../context/target_context'

import { css } from 'styled-components';
import { media } from 'styles/settings';

const BUTTON_HEIGHT = 40;

export const centerHorizontal = css`
  position: relative;
  margin: 0 auto;
`;

export const centerVertical = css`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

export const InnerContainerContent = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
  background: ${({ theme }) => theme.background};
`;

export const TrailsContainer = styled.div`
  position: relative;
  width: 100%;
  ${media.mediaQueries.mobile`
    width: 70%;
    ${centerHorizontal}
  `}
  height: calc(100% - ${BUTTON_HEIGHT}px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Title = styled(ReactSpring.animated.div)`
  position: relative;
  will-change: transform, opacity;
  overflow: hidden;
  color: ${({ theme }) => theme.text};
  text-align: center;
  font-size: 28px;
  line-height: 40px;
`;

export const MobileTitle = styled(Title)`
  ${media.mediaQueries.mobileOnly}
  top: 50%;
  color: ${({ theme }) => theme.text};
`;

export const DesktopTitle = styled(Title)`
  ${media.mediaQueries.desktopAndTabletOnly}
  margin-bottom: 80px;
  font-size: 36px;
  line-height: 55px;
`;

const ContentContainer = styled.div`
  ${media.mediaQueries.mobile`

  `}
  ${centerVertical}
  ${centerHorizontal}
`;

// const StyledCheckboxAnimation = styled.div`
//   width: 70px;
//   height: 70px;
//   ${centerHorizontal}
//   margin-bottom: 20px;
//   ${media.desktop`
//     margin-bottom: 40px;
//     width: 100px;
//     height: 100px;
//   `}
// `

// const StyledTrailsContainer = styled(TrailsContainer)`
//   margin-bottom: 80px;
// `

const StyledDesktopTitle = styled(DesktopTitle)`
  margin-bottom: 25px;
`;

const StyledMobileTitle = styled(MobileTitle)`
  margin-bottom: 25px;
  top: unset;
  color: ${({ theme }) => theme.white};
`;

const Subtitle = styled(ReactSpring.animated.div)`
  ${centerHorizontal}
  position: relative;
  will-change: transform, opacity;
  overflow: hidden;
  color: ${({ theme }) => theme.white};
  font-size: 16px;
  line-height: 25px;
  /* font-family: ${({ theme }) => theme.fonts.roboto}; */
  font-weight: 400;
  text-align: center;
  white-space: pre-wrap;
  ${media.mediaQueries.desktop`
    width: 80%;
  `}
`;

// const BottomButtonHolder = styled.div`

//   width: 100%;
//   max-width: 220px;
//   position: absolute;
//   bottom: 50px;
//   left: 50%;
//   -webkit-transform: translateX(-50%);
//   transform: translateX(-50%)
// `

export const PortraitGuard = ({ children }) => {
  // const { language } = React.useContext(LanguageContext)
  // const { targetConfig } = React.useContext(TargetContext);
  // console.log(" WINDOW ORITENTATION  ",window.orientation, isMobile, isTablet , window.innerHeight, window.innerWidth  )
  var offset = 0;
  if (
    window.innerWidth > window.innerHeight &&
    (window.orientation == 0 || window.orientation == 180)
  ) {
    offset = 90;
  }
  if (
    window.innerWidth < window.innerHeight &&
    (window.orientation == 90 || window.orientation == -90)
  ) {
    offset = 90;
  }
  let orientation = window.orientation - offset;
  let land = orientation == 90 || orientation == -90;
  //console.log(" WINDOW ORITENTATION  ",window.orientation, isMobile, isTablet , window.innerHeight, window.innerWidth , offset , land  )
  const [isLandscape, setIsLandscape] = useState(land); //)
  // const translate = SOME_ERROR_SCREEN_MESSAGES[targetConfig.translate][language]

  const skip = !isMobile || isTablet;

  useEffect(() => {
    if (!skip) {
      window.addEventListener('orientationchange', doOnOrientationChange);
      return () =>
        window.removeEventListener('orientationchange', doOnOrientationChange);
    }
  }, [skip]);

  const doOnOrientationChange = useCallback(() => {
    let orientation = window.orientation - offset;
    console.log(
      ' doOnOrientationChange ',
      window.orientation,
      window.innerHeight,
      window.innerWidth,
      orientation,
      offset,
    );
    //    setIsLandscape()
    switch (orientation) {
      case -90:
        setIsLandscape(true);
        break;
      case 90:
        setIsLandscape(true);
        break;
      default:
        setIsLandscape(false);
        break;
    }
  }, [setIsLandscape]);

  if (skip) {
    return children;
  }

  const errorScreenMessages = { title: 'Querformat wird nicht unterstützt.' };
  if (isLandscape) {
    return (
      <InnerContainerContent>
        <ContentContainer>
          {errorScreenMessages?.title && (
            <>
              <StyledMobileTitle key="mob">
                {errorScreenMessages.title}
              </StyledMobileTitle>
              <StyledDesktopTitle key="desk">
                {errorScreenMessages.title}
              </StyledDesktopTitle>
            </>
          )}
          {errorScreenMessages?.subtitle && (
            <Subtitle>{errorScreenMessages.subtitle}</Subtitle>
          )}
        </ContentContainer>
      </InnerContainerContent>
    );
  }
  return children;
};

export const withPortratitGuard = (WC) => {
  const MyComp = (props) => {
    return (
      <PortraitGuard>
        <WC {...props} />
      </PortraitGuard>
    );
  };
  MyComp.displayName = 'withPortraitGuard';
  return MyComp;
};
